import {RouteConfig} from 'vue-router/types/router';

/** Mitarbeiter:in / Lehrkraft profile (new + legacy page) and the former applicant profile route */
export const EMPLOYEE_ROUTES: RouteConfig[] = [
    {
        path: '/teachers/:employeeId',
        name: 'Lehrkraft',
        // See employees/employeeId
        component: () => import(/* webpackChunkName: "employee" */ '../views/EmployeeView.vue'),
        // ?tab= of the full views must not remount the profile
        meta: {keepOnQueryChange: true},
    },
    {
        path: '/employees/:employeeId',
        name: 'Mitarbeitende:r',
        component: () => import(/* webpackChunkName: "employee" */ '../views/EmployeeView.vue'),
        meta: {keepOnQueryChange: true},
    },
    {
        // Previous profile for comparison until the new profile covers every function (then delete with EmployeeViewLegacy.vue)
        path: '/teachers-legacy/:employeeId',
        name: 'Lehrkraft (alt)',
        component: () => import(/* webpackChunkName: "employee-legacy" */ '../views/EmployeeViewLegacy.vue'),
    },
    {
        path: '/employees-legacy/:employeeId',
        name: 'Mitarbeitende:r (alt)',
        component: () => import(/* webpackChunkName: "employee-legacy" */ '../views/EmployeeViewLegacy.vue'),
    },
    {
        // Applicants are handled in the recruiter pipeline (the profile showed no application data)
        path: '/applicants/:employeeId',
        redirect: '/recruiter/applicants/:employeeId',
    },
];
